import React from 'react'

import SurveyVideo1 from '../../../assets/images/survey-video-1.png'
import SurveyImage3 from '../../../assets/images/survey-image-3.png'
import SurveyImage4 from '../../../assets/images/survey-image-4.png'
import Media from './widgets/Media';
import Svg from '../Svg';
import Header from './widgets/Header';

export default function DetailedLandingPage() {

    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">
                <div className="banner-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="banner-text">
                                    <h1 className='heading fs-55 fw-600'>Check <span className='text-primary'>Digital Maturity</span> across 8 dimensions through our assessment.</h1>
                                    <div className="text-part">
                                        <p>Pesent aliquam tellus nibh, vitae pretium elit tincidunt sit amet. Phasellus hendrerit luctus aliquet. Integer id turpis dui. Fusce in neque at ex condimentum viverra in at nisl</p>
                                    </div>
                                    <div className="button-wrap">
                                        <a href="#0" className='btn btn-primary'>Start assessment <Svg name="right-arrow" /></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <Media type="video" channel="youtube" videoId="L61p2uyiMSo" imageUrl={SurveyVideo1} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-section section-padding left-media">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-5">
                                <div className="img-wrapper rounded-8">
                                    <Media imageUrl={SurveyImage3} />
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1">
                                <div className="text-wrap">
                                    <h2 className='heading fs-48 fw-600'>What our Digital Maturity Survey covers</h2>
                                    <div className="text-part">
                                        <p>Pesent aliquam tellus nibh, vitae pretium elit tincidunt sit amet. Phasellus hendrerit luctus aliquet. Integer id turpis dui. Fusce in neque at ex condimentum viverra in at nisl. Integer ultrices ligula eget felis faucibus, sit amet pulvinar enim elementum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor</p>
                                    </div>
                                    
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="content-section section-padding right-media">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-5">
                                <div className="text-wrap">
                                    <h2 className='heading fs-48 fw-600'>Find out where your organization is on the Digital maturity scale</h2>
                                    <div className="text-part">
                                        <p>Lesent aliquam tellus nibh, vitae pretium elit tincidunt sit amet. Phasellus hendrerit luctus aliquet. Integer id turpis dui. Fusce in neque at ex condimentum viverra in at nisl. Integer ultrices ligula eget felis faucibus, sit amet pulvinar enim elementum. Lorem ipsum dolor sit amet, consectetur adipiscing elit.Cras tempor</p>
                                    </div>
                                    
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1">
                                <div className="img-wrapper rounded-8">
                                    <Media imageUrl={SurveyImage4} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-section section-padding no-media text-center">
                    <div className="container">
                        <div className="text-wrap">
                            <h3 className='heading fs-48 fw-600'>Start your survey now</h3>
                            <div className="text-part">
                                <p className='fs-20'>The assessment contains 23 questions separated into three sections and takes around 15 minUTes to complete. At the end of the review, you will gain crucial and actionable insights to help you embed the right security and management controls to embrace many future.</p>
                            </div>
                            <div className="button-wrap">
                                <a href="#0" className='btn btn-primary'>Start assessment <Svg name="right-arrow" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

